/** @format */

import nine from "../assets/svg/projects/nine.svg";
import four from "../assets/svg/projects/four.svg";
import five from "../assets/svg/projects/five.svg";
import six from "../assets/svg/projects/six.svg";
export const projectsData = [
  {
    id: 1,
    projectName: "Personal_Website",
    projectDesc: "tis is my personal website regarding my personal infos.",
    tags: ["React", "SAAS", "React Bootstrap"],
    code: "",
    demo: "",
    image: nine,
  },
  {
    id: 3,
    projectName: "Youtube-Clone",
    projectDesc: "This project completes youtube clone .",
    tags: ["React", "Express", "Material Ui"],
    code: "https://github.com/kanav1999?tab=repositories",
    demo: "https://utube01.netlify.app",
    image: six,
  },
  {
    id: 4,
    projectName: "Crypto- Tracker",
    projectDesc: "regarding crptotraking band news.",
    tags: ["React", "SAAS", "React Bootstrap"],
    code: "https://github.com/kanav1999/crypto-tracker",
    demo: "https://crypto-tracker11.netlify.app",
    image: four,
  },
  {
    id: 2,
    projectName: "Weather App",
    projectDesc: "This project about weather forecasting.",
    tags: ["React", "CSS", "Material Ui"],
    code: "https://github.com/kanav1999/Weather-App",
    demo: "https://k-weather-app.netlify.app",
    image: five,
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
